module.exports = __webpack_public_path__ + "static/media/paige_avatar.9df93984.jpg";